import { useHasGroup } from '../../hooks/useHasGroup';

// Inline render gate: shows `children` only when the user is in `role`
// (superusers always pass). For protecting a whole route/area with a redirect,
// use RequireGroup instead.
const HasGroup = ({ role, children }) => (useHasGroup(role) ? children : null);

export default HasGroup;
